<template>
  <default-list
    :items="items"
    class="mb-n2"
  />
</template>

<script>

  import { get } from 'vuex-pathify'

  export default {
    name: 'DefaultAccountSettings',

    components: {
      DefaultList: () => import(
        /* webpackChunkName: "default-list" */
        '../List'
      ),
    },
    computed: {
      profile: get('auth/profile'),
      items () {
        return [
          {
            title: this.profile.user_name,
            avatar: 'data:image/jpeg;base64,' + this.profile.avatar.thumbnail,
            items: [
              {
                title: 'my_profile',
                icon: '$user',
                to: '/profile/edit',
              },
              {
                title: 'my_pilot_infos',
                icon: '$pilot_info',
                to: '/profile/pilot-info-edit',
              },
              {
                title: 'my_documents',
                icon: '$documents',
                to: '/profile/documents',
              },
              {
                module_on: 'financial',
                title: 'my_transactions',
                icon: '$transactions',
                to: '/profile/transactions',
              },
              {
                module_on: 'training',
                can: 'training-edit-student',
                title: 'training',
                icon: '$user_training',
                to: '/profile/training',
              },
              {
                title: 'notifications',
                icon: '$notifications',
                to: '/profile/notifications',
              },
              {
                title: 'actions',
                icon: '$actions',
                to: '/profile/actions',
              },
            ],
          },
        ]
      },
    },
  }
</script>
